export default __webpack_public_path__ + "static/franchise-8-8d075335044bf5002ed233f7d6f27de0.jpg";